// deno-fmt-ignore-file
import { RecordKey } from '../../types/record.mjs';
export function FromRecord(type) {
    return RecordKey(type);
}
